const trackGAEvent = (eventName: string) => {
  const dataLayer = window?.dataLayer

  if (Array.isArray(dataLayer)) {
    dataLayer.push({
      event: eventName,
    })
  }
}

export default trackGAEvent
